import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { useUserReviews } from '@/scopes/products/user-reviews/hooks'
import { createUserReviewsEvent } from '@/scopes/products/user-reviews/infrastructure/analytics'
import { space } from '@sunwebgroup/ui-components'
import { Switch, Typography } from '@sunwebgroup/ui-components/uds'
import React from 'react'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

const Wrapper = styled.label`
  display: flex;
  gap: ${space('primitives_space_12')};
  margin-top: ${space('primitives_space_12')};
  margin-bottom: ${space('primitives_space_12')};
  width: fit-content;

  &:hover {
    cursor: pointer;
  }
`

export function InWebsiteLanguageFilter() {
  const intl = useIntl()

  const { showOnlyInWebsiteLanguage, setShowOnlyInWebsiteLanguage } = useUserReviews()
  const { sendEvent } = useAnalytics()

  const handleOnCheckedChange = () => {
    sendEvent(
      createUserReviewsEvent({
        description: 'show review in own language',
        element: 'Toggle',
        result: showOnlyInWebsiteLanguage ? 'off' : 'on',
      }),
    )
    setShowOnlyInWebsiteLanguage(!showOnlyInWebsiteLanguage)
  }

  return (
    <Wrapper>
      <Switch checked={showOnlyInWebsiteLanguage} onCheckedChange={handleOnCheckedChange} />
      <Typography $variant="body-m-bold-tight" $color="semantics_content_secondary_color">
        {intl.formatMessage({ id: 'reviews_all_in_my_language' })}
      </Typography>
    </Wrapper>
  )
}
